import { config } from '@iheartjane/config';

import { SpecialStatus } from '@jane/business-admin/types';

enum AnalyticsRouteMapping {
  Customers = '/analytics/customers',
  Fulfillment = '/analytics/fulfillment',
  'Google Traffic' = '/analytics/google-traffic',
  'Inventory Forecasts' = '/analytics/inventory-forecasts',
  'Jane Gold' = '/analytics/jane-gold',
  KPIs = '/analytics/kpis',
  'Marketing Attribution' = '/analytics/marketing-attribution',
  Marketplace = '/analytics/marketplace',
  'Off-Menu Advertising' = '/analytics/off-menu-advertising',
  'Off-Menu Merchandising for non-Jane Ecomm' = '/analytics/off-menu-merchandising',
  'On-Menu Merchandising' = '/analytics/on-menu-merchandising',
  Pricing = '/analytics/pricing',
  Printers = '/analytics/printers',
  'Product Reviews' = '/analytics/product-reviews',
  Sales = '/analytics/sales',
  SDK = '/analytics/sdk',
  'Store Reviews' = '/analytics/store-reviews',
  Trends = '/analytics/trends',
  'Web Traffic' = '/analytics/web-traffic',
}

export const businessPaths = {
  root() {
    return '/';
  },
  login() {
    return '/login';
  },
  loggedInRoot(onlyAuthUser = false) {
    return onlyAuthUser ? this.analytics() : this.stores();
  },
  stores() {
    return '/stores';
  },
  storeSettingsDetails(id: string | undefined) {
    return `/stores/${id}/settings/details`;
  },
  storeSettingsCheckout(id: string | undefined) {
    return `/stores/${id}/settings/checkout`;
  },
  storeSettingsSpecials(id: string | undefined) {
    return `/stores/${id}/settings/specials`;
  },
  storeSettingsSubdomain(id: string | undefined) {
    return `/stores/${id}/settings/subdomain`;
  },
  storeSettingsIntegrations(id: string | undefined) {
    return `/stores/${id}/settings/integrations`;
  },
  storeSettingsFulfillments(id: string | undefined) {
    return `/stores/${id}/settings/fulfillments`;
  },
  storeSettingsNotifications(id: string | undefined) {
    return `/stores/${id}/settings/notifications`;
  },
  storeSettingsHardware(id: string | undefined) {
    return `/stores/${id}/settings/hardware`;
  },
  storeMenu(id: string | undefined) {
    return `/stores/${id}/menu`;
  },
  storeProducts(id: string, type: string) {
    return `/stores/${id}/products/${type}`;
  },
  storeSpecials(id: string, status?: SpecialStatus) {
    return `/stores/${id}/specials?status=${
      status ? status : SpecialStatus.live
    }`;
  },
  storeSpecialDetail(id: string, specialId: string) {
    return `/stores/${id}/specials/${specialId}`;
  },
  storeSpecialDuplicate(id: string, specialId: string) {
    return `/stores/${id}/specials/duplicate/${specialId}`;
  },
  storeStaff(id: string | undefined) {
    return `/stores/${id}/staff`;
  },
  storeAudit(id: string | undefined) {
    return `/stores/${id}/audit`;
  },
  specials(status?: SpecialStatus) {
    return `/specials?status=${status ? status : SpecialStatus.live}`;
  },
  globalSpecialDetail(specialId: string) {
    return `/specials/${specialId}`;
  },
  globalSpecialDuplicate(specialId: string) {
    return `/specials/duplicate/${specialId}`;
  },
  boostMenus() {
    return '/boost';
  },
  premium() {
    return '/premium';
  },
  businessSolutions() {
    return '/marketing/business-solutions';
  },
  analytics() {
    return '/analytics';
  },
  analyticsRoutes(liveboardName: string) {
    return AnalyticsRouteMapping[
      liveboardName as keyof typeof AnalyticsRouteMapping
    ];
  },
  fulfillment() {
    return config.fulfillmentV2;
  },
};
